"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataTapeField = void 0;
/**
 * ============= DATA TAPE FIELD =============
 */
var DataTapeField;
(function (DataTapeField) {
    DataTapeField.NumericTypes = [
        'currency',
        'float',
        'integer',
        'percentage',
        'optionalCurrency',
        'optionalFloat',
        'optionalInteger',
        'optionalPercentage',
    ];
    DataTapeField.ValidTypes = [
        'boolean',
        'date',
        'dateTime',
        'string',
        'optionalBoolean',
        'optionalDate',
        'optionalDateTime',
        'optionalString',
        ...DataTapeField.NumericTypes,
    ];
})(DataTapeField = exports.DataTapeField || (exports.DataTapeField = {}));
//# sourceMappingURL=DataTapeField.js.map